export const ArticleTitleValidation = {
  validate: {
    notEmpty: (value: string) => value.trim() !== "" || "Required",
    minLength: (value: string) =>
      value.trim().length >= 5 ||
      "Title length must be at least 5 characters long",
  },
};
